import { usePayPointsQuery } from "Api/Queries/PayPoints/usePayPointsQuery";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { SimpleMobileLayout } from "Components/Layout/SimpleMobileLayout";
import { ActiveTransactionConflictModal } from "Components/Merchant/Initiate/ActiveTransactionConflictModal";
import { InitiatePaymentKeypad } from "Components/Merchant/Initiate/InitiatePaymentKeypad/InitiatePaymentKeypad";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useAmount } from "Hooks/useAmount";
import { useInitiatePaypointPayment } from "Hooks/useInitiatePaypointPayment";
import { useIsMobile } from "Hooks/useIsMobile";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";
import { getTransactionErrorMessage } from "Utils/TransactionErrorsUtils";

const RESOURCES = Resources.Employee.KeypadPayment;

export const EmployeeInitiateKeypadPaymentPage = () => {
  const isMobile = useIsMobile();
  const { t } = useResource();

  const { data, isLoading: isLoadingPaypoints } = usePayPointsQuery(0, 100);

  const {
    initiateTransaction,
    isPending,
    conflictingTransaction,
    resetConflictingTransaction,
  } = useInitiatePaypointPayment({
    onError: (error) => {
      const message = getTransactionErrorMessage(error, t);
      toast.error(message);
    },
  });

  const isDisabled = isLoadingPaypoints || isPending;
  const paypoints = data?.items || [];
  const toAmountWithCurrency = useAmount();

  const pageContent = (
    <StyledPageWrapper>
      <PrimaryPaper>
        <InitiatePaymentKeypad
          isUsedByEmployee
          isDisabled={isDisabled}
          paypoints={paypoints}
          onPay={(amount, payPointPublicID) =>
            initiateTransaction({
              payPointPublicID,
              amount: toAmountWithCurrency(amount),
            })
          }
        />
        {conflictingTransaction && (
          <ActiveTransactionConflictModal
            pendingTransaction={conflictingTransaction}
            onCancel={resetConflictingTransaction}
          />
        )}
      </PrimaryPaper>
    </StyledPageWrapper>
  );

  if (isMobile) {
    return (
      <SimpleMobileLayout title={t(RESOURCES.Title)}>
        {pageContent}
      </SimpleMobileLayout>
    );
  }

  return (
    <AuthenticatedLayout
      title={t(RESOURCES.Title)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null,
      }}
    >
      {pageContent}
    </AuthenticatedLayout>
  );
};

export default EmployeeInitiateKeypadPaymentPage;
